import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@emotion/react';

const MWETable = ({ months, outputs, inputs }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <TableContainer
      sx={{
        borderRadius: '9px',
        // border: '1px solid #EBEBEB',
        mt: 6,
        width: isMobile ? '100%' : '70%',
      }}
    >
      <Table size='small'>
        <TableHead>
          <TableRow hover>
            <TableCell sx={{ fontWeight: 'bold' }}>Month</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              Generation (units)
            </TableCell>
            {/* <TableCell sx={{ fontWeight: 'bold' }}>Soiling (%)</TableCell> */}
            <TableCell sx={{ fontWeight: 'bold' }}>
              Sunlight (kWh/m²/day)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {months.map((month, index) => (
            <TableRow hover key={month}>
              <TableCell>{month}</TableCell>
              <TableCell>
                {outputs.ac_monthly?.[index]?.toFixed(1) || 'N/A'}
              </TableCell>
              {/* <TableCell>{inputs.soiling?.[index] || 'N/A'}</TableCell> */}
              <TableCell>
                {outputs.solrad_monthly?.[index]?.toFixed(2) || 'N/A'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MWETable;
